<template>
  <div class="time-line-container">
    <div v-for="(data, day) in dataSourceCopy" :key="day" class="time-line-item">
      <div class="item-set-box">
        <div class="item-set" v-for="(item, itemIndex) in data" :key="itemIndex">
          <div v-if="itemIndex == 0" class="time-label">
            {{ exchangeDay(day) }}
          </div>
          <div class="dot-box">
            <slot :data="item" name="dot">
              <div class="dot-default">
                <img class="dot-pic" :src="exchangeToDot(item.country)" alt="" />
              </div>
            </slot>
          </div>
          <div class="content-box" @click="openTimeLineDialog(item)">
            <slot :data="item" name="content">
              <p class="content-default">{{ item.event }} <span v-if="item.textInfo">>>></span> <img v-if="item.extensionUrl" src="../../assets/images/link2.png" alt="" /> <img v-if="item.videoUrl" style="width:22px;height:22px" src="../../assets/images/video.png" alt="" /></p>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="time-bar"></div>
  </div>
</template>

<script>
const timeDotFlag = {
  澳大利亚: require("@/assets/images/澳大利亚.png"),
  德国: require("@/assets/images/德国.png"),
  法国: require("@/assets/images/法国.png"),
  韩国: require("@/assets/images/韩国.png"),
  加拿大: require("@/assets/images/加拿大.png"),
  美国: require("@/assets/images/美国.png"),
  伊朗: require("@/assets/images/伊朗.png"),
  意大利: require("@/assets/images/意大利.png"),
  英国: require("@/assets/images/英国.png"),
  伊拉克: require("@/assets/images/伊拉克.png"),
  日本: require("@/assets/images/日本.png"),
  西班牙: require("@/assets/images/西班牙.png"),
  俄罗斯: require("@/assets/images/俄罗斯.png")
};
//../../assets/images/texttimeline.png <img :src="imgUrl" alt="">
export default {
  props: {
    dataSource: {
      required: true,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    dataSource(newValue) {
      this.dataSourceCopy = newValue;
    }
  },
  data() {
    return {
      dataSourceCopy: this.dataSource,
    };
  },
  methods: {
    openTimeLineDialog(value) {
      setTimeout(() => {
        const avi = document.querySelector("#avi");
        if (avi) {
          avi.play();
        }
      }, 500)
      if (value.textInfo == "" && value.extensionUrl == "" && value.videoUrl == "") {
        return false
      } else {
        if (value.extensionUrl) {
          window.open(value.extensionUrl)
        } else {
          //  ModalHelper.afterOpen();
          this.$emit("showDialog", value)
        }
      }
    },
    exchangeToDot(countryName) {
      return timeDotFlag[countryName];
    },
    exchangeDay(day) {
      let time = new Date(day);
      let month = time.getMonth() + 1;
      let days = time.getDate();
      if (days < 10) days = "0" + days;
      if (month < 10) month = "0" + month;
      return `${month}月${days}日`;
    }
  }
};
</script>

<style lang="less" scoped="scoped">
.time-line-container {
  position: relative;
  padding-top: 15px;
  padding-left: 10px;
  z-index: 10;

  .time-bar {
    width: 1px;
    height: 100%;
    border: solid 1px #e1e1e1;
    position: absolute;
    top: 0;
    left: 81px;
    z-index: -1;
  }

  .time-line-item {
    display: flex;
    flex-flow: row nowrap;
    align-items: top;

    .time-label {
      width: 53px;
      height: 12px;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 12px;
      letter-spacing: 0px;
      color: #7d7d7d;
      margin-right: 5px;
    }

    .item-set-box {
      margin-bottom: 11px;

      .item-set {
        display: flex;
        flex-flow: row nowrap;
        margin-bottom: 11px;
        align-items: center;
        margin-left: 58px;

        .dot-box {
          .dot-default {
            margin-right: 11px;

            .dot-pic {
              display: block;
              width: 28px;
              height: 28px;
              border: 3px solid #d4d4d4;
              border-radius: 50%;
            }
          }
        }

        .content-box {
          position: relative;

          .content-default {
            padding: 10px 14px;
            max-width: 215px;
            background-color: #ff604e;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 15px;
            letter-spacing: 1px;
            color: #ffffff;
            border-radius: 3px;

            img {
              width: 20px;
              height: 20px;
              vertical-align: middle;
            }
          }

          .content-default:before {
            content: "";
            width: 0;
            height: 0;
            overflow: hidden;
            font-size: 0;
            line-height: 0;
            border-width: 5px;
            position: absolute;
            top: 50%;
            left: -9px;
            border-style: solid dashed dashed dashed;
            border-color: transparent #ff604e transparent transparent;
            transform: translate(0, -50%);
          }
        }
      }

      .item-set:nth-child(1) {
        margin-left: 0;
      }

      .item-set:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
